import { USER } from "@src/user"
import { callApi } from "../callApi"

export const getUsersMe = async () =>
  callApi<null, USER>({
    method: "GET",
    path: "/users/me",
  })
